"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";

import { links } from "@/data/links";
import { useLang } from "@/hooks/use-lang";

import { PopularArticles } from "../../services/popular-article-list";

export const PopularArticleElement = ({
  article,
  index,
}: {
  article: PopularArticles;
  index: number;
}) => {
  const router = useRouter();
  const { lang } = useLang();
  const onClickArticle = ({ slug }: { slug: string }) => {
    if (slug) router.push(`/${lang}/${links.myBlogDetail({ slug })}`);
  };
  const { previewPicture, coverPicture, title } = article;
  return (
    <li
      className="group/popular-article-item flex cursor-pointer items-center gap-5 rounded-md px-2 py-3 transition-all hover:bg-zinc-100 hover:shadow-sm"
      data-testid={`popular-article-card-${index}`}
      onClick={() =>
        onClickArticle({ slug: encodeURIComponent(article.slug ?? "") })
      }
    >
      <Image
        src={previewPicture ?? coverPicture ?? ""}
        alt="popular-article-image"
        width={50}
        height={50}
        className="aspect-1 w-full max-w-[50px] bg-gray-200"
      />
      <p className="line-clamp-2 overflow-ellipsis text-zinc-700 transition-all group-hover/popular-article-item:text-zinc-900">
        {title}
      </p>
    </li>
  );
};
